<!-- 角色新增,修改 -->
<template>
    <el-dialog :title="title" :modal-append-to-body="false" :visible.sync="visible" width="40%" :close-on-click-modal="false" :before-close="cancel" :close-on-press-escape="true">
        <el-form :model="form" ref="roleForm" :rules="rules" autocomplete="off" label-width="120px">
            <el-form-item label="角色名" style="margin-top: 20px;" prop="roleName">
                <el-input v-model="form.roleName" autocomplete="off" style="width:75%" maxlength="60" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="description">
                <el-input v-model="form.description" autocomplete="off" style="width:75%" maxlength="60" show-word-limit></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "roleManage",
    data() {
        return {
            visible: false,
            operType: "",
            title: "",
            form: {
                roleName: "",
                description: ""
            },
            rules: {
                roleName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 1, max: 60, message: '长度在 1 到 60 个字符', trigger: 'blur' },
                ],
                description: [
                ]
            }
        }
    },
    methods: {
        open(operType, roleData) {
            switch (operType) {
                case "addRole":
                    this.title = "新增角色";
                    this.operType = "save";
                    this.form = {
                        roleName: "",
                        description: ""
                    }
                    break;
                case "updateRole":
                    this.title = "修改角色";
                    this.operType = "update";
                    this.form = {
                        ...this.form,
                        ...roleData
                    };
                    break;
                default:
                    return;
            }
            this.visible = true;
        },
        // 提交修改
        commit() {
            if (!this.form.roleName) {
                this.$message.error('必填项不能为空')
                return false
            }

            this.$api.getRoleType(this.operType, {
                ...this.form,
            }).then(res => {
                if(res.errcode != 0) return false;
                if (this.operType == "save") {
                    this.$message.success('新增成功!')
                } else {
                    this.$message.success('修改成功!')
                }
                this.$emit("handleDone");
                this.visible = false
            })
        },
        submitForm() {
            this.$refs["roleForm"].validate((valid) => {
                if (valid) {
                    this.commit();
                } else {
                    return false;
                }
            });
        },
        cancel(){
            this.$refs.roleForm.resetFields()
            this.visible = false;
        }
    }
}
</script>
<style lang="sass" scoped>
</style>